import { render, staticRenderFns } from "./PoliticamenteExposto.vue?vue&type=template&id=29bb6d0d&"
import script from "./PoliticamenteExposto.vue?vue&type=script&lang=js&"
export * from "./PoliticamenteExposto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports